export default {
  navigation: {
    spot: 'Spot',
    swap: 'Swap',
    trade: 'Trade',
    swaps: 'Swaps',
    stocks: 'Stocks',
    points: 'Points',
    orders: 'Orders',
    markets: 'Markets',
    history: 'History',
    balances: 'Balances',
    settings: 'Settings',
    portfolio: 'Portfolio',
    positions: 'Positions',
    myAccount: 'My Account',
    disconnect: 'Disconnect',
    derivative: 'Derivative',
    noTierLevel: 'No VIP Tier',
    subaccounts: 'Subaccounts',
    leaderboard: 'Leaderboard',
    tradingBots: 'Trading Bots',
    fundingHistory: 'Funding History',
    subaccountHistory: 'Subaccount History',
    makerTakerFee: '-{maker}% maker / -{taker}% taker',
    more: {
      olp: 'OLP',
      title: 'More',
      vaults: 'Vaults',
      bridge: 'Bridge',
      deposit: 'Deposit',
      referral: 'Referral',
      lpRewards: 'LP Rewards'
    }
  },

  footer: {
    blog: 'Blog',
    v2: ' Version 2.0',
    support: 'Support',
    docs: 'Helix Docs',
    explorer: 'Explorer',
    resources: 'Resources',
    community: 'Community',
    operational: 'Operational',
    feeDiscounts: 'Fee Discounts',
    institutional: 'Institutional',
    privacyPolicy: 'Privacy Policy',
    apiDocumentation: 'API Documentation',
    termsAndConditions: 'Terms & Conditions',
    helixProvides:
      'Note: Helix is able to provide maker rebates across a number of markets as approved via the Injective DAO.'
  }
}
